// @ts-strict-ignore
import type {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {QueryFormulaEntry} from 'common/query-builder/query-entry-section/types';
import {MetricType} from 'common/types/reports/bookmark';
import {ResourceType} from 'common/report/constants';

// eslint-disable-next-line import/no-cycle
import {FormulaEntryRow} from './index';
import {getDefinition, getNewInlineEntry, hasFormulaError} from './utils';

export const helpers: EntryRowTypeHelpers<QueryFormulaEntry> = {
  component: FormulaEntryRow,
  getNewEntry(section) {
    const savedFormulas = section.props.metrics
      .getAllValues()
      .filter((metric) => metric.type === MetricType.Formula && metric.can_view);
    return {
      type: ResourceType.Formula,
      event:
        section.props.metrics.isLoadingAll() || savedFormulas.length > 0
          ? null
          : getNewInlineEntry(section.getEntries(), section.props.queryOrigin),
      filters: [],
    };
  },
  isPlaceholder(row) {
    return (
      row.entry.event === null ||
      getDefinition(row.entry, row.metricsCtx, row.behaviorsCtx) === `` ||
      hasFormulaError(row, row.metricsCtx, row.behaviorsCtx)
    );
  },
  isIntermediatePlaceholder(row) {
    return hasFormulaError(row, row.metricsCtx, row.behaviorsCtx);
  },
};
